'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _settings = require('./settings');

var _orderDetail = require('./order-detail');

var _orderOverview = require('./order-overview');

var _contractsOverview = require('./contracts-overview');

var _orderDetailHeader = require('./components/order-detail-header');

var _orderDetailProducts = require('./components/order-detail-products');

var _orderDetailDeliveries = require('./components/order-detail-deliveries');

var _orderDetailDeliveryHistory = require('./components/order-detail-delivery-history');

var _orderDetailDeliveryProducts = require('./components/order-detail-delivery-products');

var _orderDetailExtraInfo = require('./components/order-detail-extra-info');

var _orderOverviewSearch = require('./components/order-overview-search');

var _contractDetail = require('./contract-detail');

var _contractDetailInfo = require('./components/contract-detail-info');

var _contractsOverviewInfo = require('./components/contracts-overview-info');

var _contractProducts = require('./components/contract-products');

var _myDocuments = require('./my-documents');

var _myReservations = require('./my-reservations');

var _rentalOverview = require('./rental-overview');

var _rentalRequestArchive = require('./rental-request-archive');

var _rentedProductArchive = require('./rented-product-archive');

var _rentedProductDetail = require('./rented-product-detail');

var _podOrderAdd = require('./my-packages/pod-order-add');

var _podOrderAddConfirmation = require('./my-packages/pod-order-add-confirmation');

var _podOrderArchive = require('./my-packages/pod-order-archive');

var _podOrderDetail = require('./my-packages/pod-order-detail');

var _podOrderOverview = require('./my-packages/pod-order-overview');

var _addStep1SelectReceiverForm = require('./my-packages/components/add-step1-select-receiver-form');

var _addStep1SelectReceiverRead = require('./my-packages/components/add-step1-select-receiver-read');

var _addStep2DetailsForm = require('./my-packages/components/add-step2-details-form');

var _addStep2DetailsRead = require('./my-packages/components/add-step2-details-read');

var _addStep3ConfirmForm = require('./my-packages/components/add-step3-confirm-form');

var _howDoesItWorkBox = require('./my-packages/components/how-does-it-work-box');

var _orderReceiverDetail = require('./my-packages/components/order-receiver-detail');

var _orderDetailContent = require('./my-packages/components/order-detail-content');

var _orderSearchResultItem = require('./my-packages/components/order-search-result-item');

var _orderState = require('./my-packages/components/order-state');

var _orderLineState = require('./my-packages/components/order-line-state');

var _orderLineDetail = require('./my-packages/components/order-line-detail');

var _orderLineStateHistory = require('./my-packages/components/order-line-state-history');

var _parcelsOverview = require('./parcels/parcels-overview');

var _parcelAdd = require('./parcels/parcel-add');

var _parcelAddConfirmation = require('./parcels/parcel-add-confirmation');

var _parcelArchive = require('./parcels/parcel-archive');

var _parcelDetail = require('./parcels/parcel-detail');

var _parcelHowDoesItWorkBox = require('./parcels/components/parcel-how-does-it-work-box');

var _parcelAddStep1SelectReceiverForm = require('./parcels/components/parcel-add-step1-select-receiver-form');

var _parcelAddStep1SelectReceiverRead = require('./parcels/components/parcel-add-step1-select-receiver-read');

var _parcelAddStep2DetailsForm = require('./parcels/components/parcel-add-step2-details-form');

var _parcelAddStep2DetailsRead = require('./parcels/components/parcel-add-step2-details-read');

var _parcelAddStep3ConfirmForm = require('./parcels/components/parcel-add-step3-confirm-form');

var _parcelSearchResultItem = require('./parcels/components/parcel-search-result-item');

var _parcelReceiverDetail = require('./parcels/components/parcel-receiver-detail');

var _parcelLineState = require('./parcels/components/parcel-line-state');

var _parcelState = require('./parcels/components/parcel-state');

var _parcelDetailContent = require('./parcels/components/parcel-detail-content');

var _parcelLineDetail = require('./parcels/components/parcel-line-detail');

var _parcelLineStateHistory = require('./parcels/components/parcel-line-state-history');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _module = _angular2.default.module('app.account', []).config(["$stateProvider", function ($stateProvider) {
    'ngInject';

    $stateProvider.state('account', {
        parent: 'general',
        url: '/account',
        ncyBreadcrumb: {
            label: '{{"My account" | translate}}'
        },
        redirectTo: 'account-detail'
    }).state('account-detail', {
        parent: 'general',
        url: '/account',
        views: {
            'main@root': {
                component: 'accountSettings'
            }
        },
        resolve: {
            user: ["userService", function user(userService) {
                return userService.getMyAccount();
            }]
        },
        params: {
            loadingOverlay: true
        },
        ncyBreadcrumb: {
            label: '{{"My account" | translate}}'
        }
    }).state('rental-overview', {
        parent: 'account',
        url: '/rentals?page',
        views: {
            'main@root': {
                component: 'rentalOverview'
            }
        },
        params: {
            loadingOverlay: true
        },
        resolve: {
            tgzId: ["sellerService", function tgzId(sellerService) {
                return sellerService.getAllForMenu().then(function (results) {
                    return results.find(function (s) {
                        return s.code === 'TGZ';
                    }).id;
                });
            }],
            statuses: ["rentalProductsService", function statuses(rentalProductsService) {
                return rentalProductsService.getHistoryStatuses();
            }]
        },
        ncyBreadcrumb: {
            label: '{{"My rent overview" | translate}}'
        },
        data: {
            febelcoCustomer: true
        }
    }).state('rented-product-detail', {
        parent: 'rented-product-archive',
        url: '/{id:int}',
        views: {
            'main@root': {
                component: 'rentedProductDetail'
            }
        },
        resolve: {
            tgzId: ["sellerService", function tgzId(sellerService) {
                return sellerService.getAllForMenu().then(function (results) {
                    return results.find(function (s) {
                        return s.code === 'TGZ';
                    }).id;
                });
            }],
            rentalHistory: ["$stateParams", "rentalProductsService", function rentalHistory($stateParams, rentalProductsService) {
                return rentalProductsService.getHistoryById($stateParams.id);
            }]
        },
        params: {
            loadingOverlay: true
        },
        ncyBreadcrumb: {
            label: '{{"Rented product detail" | translate}}'
        },
        data: {
            febelcoCustomer: true
        }
    }).state('rented-product-archive', {
        parent: 'rental-overview',
        url: '/rented-product-archive?page&pageSize&statusId&product&year&remark&depositRefunded',
        views: {
            'main@root': {
                component: 'rentedProductArchive'
            }
        },
        resolve: {
            tgzId: ["sellerService", function tgzId(sellerService) {
                return sellerService.getAllForMenu().then(function (results) {
                    return results.find(function (s) {
                        return s.code === 'TGZ';
                    }).id;
                });
            }],
            statuses: ["rentalProductsService", function statuses(rentalProductsService) {
                return rentalProductsService.getHistoryStatuses();
            }]
        },
        reloadOnSearch: false,
        params: {
            loadingOverlay: false,
            page: {
                value: '1',
                squash: true
            },
            pageSize: {
                value: window.localStorage.getItem('pageSize'),
                squash: true
            },
            statusId: {
                value: null,
                squash: true
            },
            product: {
                value: '',
                squash: true
            },
            year: {
                value: null,
                squash: true
            },
            remark: {
                value: '',
                squash: true
            },
            depositRefunded: {
                value: null,
                squash: true
            }
        },
        ncyBreadcrumb: {
            label: '{{"All my rented products" | translate}}'
        },
        data: {
            febelcoCustomer: true
        }
    }).state('rental-request-archive', {
        parent: 'rental-overview',
        url: '/request-archive?page&pageSize&product&year',
        views: {
            'main@root': {
                component: 'rentalRequestArchive'
            }
        },
        reloadOnSearch: false,
        params: {
            loadingOverlay: false,
            page: {
                value: '1',
                squash: true
            },
            pageSize: {
                value: window.localStorage.getItem('pageSize'),
                squash: true
            },
            product: {
                value: '',
                squash: true
            },
            year: {
                value: null,
                squash: true
            }
        },
        resolve: {
            tgzId: ["sellerService", function tgzId(sellerService) {
                return sellerService.getAllForMenu().then(function (results) {
                    return results.find(function (s) {
                        return s.code === 'TGZ';
                    }).id;
                });
            }]
        },
        ncyBreadcrumb: {
            label: '{{"All my rental requests" | translate}}'
        },
        data: {
            febelcoCustomer: true
        }
    }).state('order-overview', {
        parent: 'account',
        url: '/orders?page',
        views: {
            'main@root': {
                component: 'orderOverview'
            }
        },
        resolve: {
            input: ["orderService", "Enums", function input(orderService, Enums) {
                return orderService.getByCriteria('', 1, Enums.getAmounts.default, 'OrderDate', false, 0);
            }],
            sellers: ["sellerService", "gettextCatalog", function sellers(sellerService, gettextCatalog) {
                return sellerService.getAll().then(function (sellers) {
                    var newSellers = _angular2.default.copy(sellers);

                    // add all sellers option
                    newSellers.unshift({
                        id: 0,
                        name: gettextCatalog.getString('All sellers')
                    });
                    return newSellers;
                });
            }]
        },
        params: {
            loadingOverlay: true
        },
        reloadOnSearch: false,
        ncyBreadcrumb: {
            label: '{{"My orders" | translate}}'
        }
    }).state('order', {
        parent: 'order-overview',
        url: '/{id:int}',
        views: {
            'main@root': {
                component: 'orderDetail'
            }
        },
        resolve: {
            order: ["$stateParams", "orderService", function order($stateParams, orderService) {
                return orderService.getById($stateParams.id);
            }]
        },
        params: {
            loadingOverlay: true
        },
        ncyBreadcrumb: {
            label: '{{"Order - noun" | translate}} {{$resolve.order.referenceNumber}}'
        }
    }).state('contracts-overview', {
        parent: 'account',
        url: '/contracts',
        views: {
            'main@root': {
                component: 'contractsOverview'
            }
        },
        resolve: {
            contracts: ["$stateParams", "contractService", function contracts($stateParams, contractService) {
                return contractService.get();
            }]
        },
        params: {
            loadingOverlay: true
        },
        ncyBreadcrumb: {
            label: '{{"My contracts" | translate}}'
        },
        data: {
            febelcoCustomer: true
        }
    }).state('contract-detail', {
        parent: 'contracts-overview',
        url: '/{id:int}',
        views: {
            'main@root': {
                component: 'contractDetail'
            }
        },
        resolve: {
            contract: ["$stateParams", "contractService", function contract($stateParams, contractService) {
                return contractService.getById($stateParams.id);
            }]
        },
        params: {
            loadingOverlay: true
        },
        ncyBreadcrumb: {
            label: '{{$resolve.contract.name}}'
        },
        data: {
            febelcoCustomer: true
        }
    }).state('my-documents', {
        parent: 'account',
        url: '/myDocuments',
        views: {
            'main@root': {
                component: 'myDocuments'
            }
        },
        params: {},
        ncyBreadcrumb: {
            label: '{{"_myDocuments.myDocuments" | translate}}'
        },
        data: {
            febelcoCustomer: true
        }
    }).state('my-reservations', {
        parent: 'account',
        url: '/myReservations',
        views: {
            'main@root': {
                component: 'myReservations'
            }
        },
        ncyBreadcrumb: {
            label: '{{"My reservations" | translate}}'
        },
        data: {
            febelcoCustomer: true
        }
    }).state('my-packages', {
        parent: 'account',
        url: '/my-packages',
        views: {
            'main@root': {
                component: 'podOrderOverview'
            }
        },
        resolve: {
            recentOrders: ["packagesService", function recentOrders(packagesService) {
                return packagesService.getRecentOrders();
            }]
        },
        params: {
            loadingOverlay: true
        },
        ncyBreadcrumb: {
            label: 'Mijn verzendingen'
        },
        data: {
            febelcoCustomer: true
        }
    }).state('package-archive', {
        parent: 'my-packages',
        url: '/package-archive',
        views: {
            'main@root': {
                component: 'podOrderArchive'
            }
        },
        resolve: {
            orders: ["packagesService", function orders(packagesService) {
                return packagesService.getOrders();
            }]
        },
        params: {
            loadingOverlay: true
        },
        ncyBreadcrumb: {
            label: 'Al mijn verzendingen'
        },
        data: {
            febelcoCustomer: true
        }
    }).state('package-detail', {
        parent: 'my-packages',
        url: '/{id:int}',
        views: {
            'main@root': {
                component: 'podOrderDetail'
            }
        },
        resolve: {
            order: ["$stateParams", "packagesService", function order($stateParams, packagesService) {
                return packagesService.getById($stateParams.id);
            }]
        },
        params: {
            loadingOverlay: true
        },
        ncyBreadcrumb: {
            label: 'Verzending {{$resolve.order.orderNumber}}'
            // label: '{{$resolve.contract.name}}'
        },
        data: {
            febelcoCustomer: true
        }
    }).state('add-package', {
        parent: 'my-packages',
        url: '/add-package',
        views: {
            'main@root': {
                component: 'podOrderAdd'
            }
        },
        resolve: {
            /*     contract: ($stateParams, contractService) => {
                    return contractService.getById($stateParams.id);
                } */
        },
        params: {
            loadingOverlay: true
        },
        ncyBreadcrumb: {
            label: 'Verzending aanmaken'
            // label: '{{$resolve.contract.name}}'
        },
        data: {
            febelcoCustomer: true
        }
    }).state('add-package-confirmation', {
        parent: 'my-packages',
        url: '/add-package-confirmation',
        views: {
            'main@root': {
                component: 'podOrderAddConfirmation'
            }
        },
        resolve: {
            order: ["packagesService", function order(packagesService) {
                return packagesService.getById(99);
            }]
        },
        params: {
            loadingOverlay: true
        },
        ncyBreadcrumb: {
            label: 'Verzending aangemaakt'
        },
        data: {
            febelcoCustomer: true
        }
    }).state('parcels', {
        parent: 'account',
        url: '/parcels',
        views: {
            'main@root': {
                component: 'parcelsOverview'
            }
        },
        params: {
            loadingOverlay: true
        },
        ncyBreadcrumb: {
            label: '{{"parcel.myParcels" | translate}}'
        },
        data: {
            febelcoCustomer: true
        }
    }).state('parcel-archive', {
        parent: 'parcels',
        url: '/parcel-archive?page&pageSize&identification&barCode&orderNumber&dateFrom&dateTo',
        views: {
            'main@root': {
                component: 'parcelArchive'
            }
        },
        reloadOnSearch: false,
        params: {
            loadingOverlay: false,
            page: {
                value: '1',
                squash: true
            },
            pageSize: {
                value: window.localStorage.getItem('pageSize'),
                squash: true
            },
            identification: {
                value: '',
                squash: true
            },
            barCode: {
                value: '',
                squash: true
            },
            orderNumber: {
                value: '',
                squash: true
            },
            dateFrom: {
                value: null,
                squash: true
            },
            dateTo: {
                value: null,
                squash: true
            }
        },
        ncyBreadcrumb: {
            label: '{{"parcel.allMyParcels" | translate}}'
        },
        data: {
            febelcoCustomer: true
        }
    }).state('add-parcel', {
        parent: 'parcels',
        url: '/add-parcel',
        views: {
            'main@root': {
                component: 'parcelAdd'
            }
        },
        resolve: {
            data: ["parcelService", function data(parcelService) {
                return parcelService.init();
            }]
        },
        params: {
            loadingOverlay: true
        },
        ncyBreadcrumb: {
            label: '{{"parcel.createParcel" | translate}}'
        },
        data: {
            febelcoCustomer: true
        }
    }).state('add-parcel-confirmation', {
        parent: 'parcels',
        url: '/add-parcel-confirmation/{id:int}',
        views: {
            'main@root': {
                component: 'parcelAddConfirmation'
            }
        },
        resolve: {
            parcel: ["$stateParams", "parcelService", function parcel($stateParams, parcelService) {
                return parcelService.get($stateParams.id);
            }]
        },
        params: {
            loadingOverlay: true
        },
        ncyBreadcrumb: {
            label: '{{"parcel.yourParcelWasRegistered" | translate}}'
        },
        data: {
            febelcoCustomer: true
        }
    }).state('parcel-detail', {
        parent: 'parcels',
        url: '/{id:int}',
        views: {
            'main@root': {
                component: 'parcelDetail'
            }
        },
        resolve: {
            parcelId: ["$stateParams", function parcelId($stateParams) {
                return $stateParams.id;
            }]
        },
        params: {
            loadingOverlay: true
        },
        ncyBreadcrumb: {
            label: '{{"parcel.parcel" | translate}} {{$resolve.parcel.orderNumber}}'
        },
        data: {
            febelcoCustomer: true
        }
    });
}]).component('accountSettings', _settings.accountSettingsComponent).component('orderOverview', _orderOverview.orderOverviewComponent).component('orderDetail', _orderDetail.orderDetailComponent).component('orderDetailHeader', _orderDetailHeader.orderDetailHeaderComponent).component('orderDetailProducts', _orderDetailProducts.orderDetailProductsComponent).component('orderDetailDeliveries', _orderDetailDeliveries.orderDetailDeliveriesComponent).component('orderDetailDeliveryHistory', _orderDetailDeliveryHistory.orderDetailDeliveryHistoryComponent).component('orderDetailDeliveryProducts', _orderDetailDeliveryProducts.orderDetailDeliveryProductsComponent).component('orderDetailExtraInfo', _orderDetailExtraInfo.orderDetailExtraInfoComponent).component('orderOverviewSearch', _orderOverviewSearch.orderOverviewSearchComponent).component('contractsOverview', _contractsOverview.contractsOverviewComponent).component('contractDetailInfo', _contractDetailInfo.contractDetailInfoComponent).component('contractsOverviewInfo', _contractsOverviewInfo.contractsOverviewInfoComponent).component('contractProducts', _contractProducts.contractProductsComponent).component('myDocuments', _myDocuments.myDocumentsComponent).component('myReservations', _myReservations.myReservationsComponent).component('contractDetail', _contractDetail.contractDetailComponent).component('rentalOverview', _rentalOverview.rentalOverviewComponent).component('rentalRequestArchive', _rentalRequestArchive.rentalRequestArchiveComponent).component('rentedProductArchive', _rentedProductArchive.rentedProductArchiveComponent).component('rentedProductDetail', _rentedProductDetail.rentedProductDetailComponent).component('podOrderAdd', _podOrderAdd.podOrderAddComponent).component('podOrderAddConfirmation', _podOrderAddConfirmation.podOrderAddConfirmationComponent).component('podOrderArchive', _podOrderArchive.podOrderArchiveComponent).component('podOrderDetail', _podOrderDetail.podOrderDetailComponent).component('podOrderOverview', _podOrderOverview.podOrderOverviewComponent).component('addStep1SelectReceiverForm', _addStep1SelectReceiverForm.addStep1SelectReceiverFormComponent).component('addStep1SelectReceiverRead', _addStep1SelectReceiverRead.addStep1SelectReceiverReadComponent).component('addStep2DetailsForm', _addStep2DetailsForm.addStep2DetailsFormComponent).component('addStep2DetailsRead', _addStep2DetailsRead.addStep2DetailsReadComponent).component('addStep3ConfirmForm', _addStep3ConfirmForm.addStep3ConfirmFormComponent).component('howDoesItWorkBox', _howDoesItWorkBox.howDoesItWorkBoxComponent).component('orderReceiverDetail', _orderReceiverDetail.orderReceiverDetailComponent).component('orderDetailContent', _orderDetailContent.orderDetailContentComponent).component('orderSearchResultItem', _orderSearchResultItem.orderSearchResultItemComponent).component('orderState', _orderState.orderStateComponent).component('orderLineState', _orderLineState.orderLineStateComponent).component('orderLineDetail', _orderLineDetail.orderLineDetailComponent).component('orderLineStateHistory', _orderLineStateHistory.orderLineStateHistoryComponent).component('parcelAdd', _parcelAdd.parcelAddComponent).component('parcelAddConfirmation', _parcelAddConfirmation.parcelAddConfirmationComponent).component('parcelsOverview', _parcelsOverview.parcelsOverviewComponent).component('parcelArchive', _parcelArchive.parcelArchiveComponent).component('parcelDetail', _parcelDetail.parcelDetailComponent).component('parcelHowDoesItWorkBox', _parcelHowDoesItWorkBox.parcelHowDoesItWorkBoxComponent).component('parcelAddStep1SelectReceiverForm', _parcelAddStep1SelectReceiverForm.parcelAddStep1SelectReceiverFormComponent).component('parcelAddStep1SelectReceiverRead', _parcelAddStep1SelectReceiverRead.parcelAddStep1SelectReceiverReadComponent).component('parcelAddStep2DetailsForm', _parcelAddStep2DetailsForm.parcelAddStep2DetailsFormComponent).component('parcelAddStep2DetailsRead', _parcelAddStep2DetailsRead.parcelAddStep2DetailsReadComponent).component('parcelAddStep3ConfirmForm', _parcelAddStep3ConfirmForm.parcelAddStep3ConfirmFormComponent).component('parcelReceiverDetail', _parcelReceiverDetail.parcelReceiverDetailComponent).component('parcelDetailContent', _parcelDetailContent.parcelDetailContentComponent).component('parcelSearchResultItem', _parcelSearchResultItem.parcelSearchResultItemComponent).component('parcelLineState', _parcelLineState.parcelLineStateComponent).component('parcelState', _parcelState.parcelStateComponent).component('parcelLineDetail', _parcelLineDetail.parcelLineDetailComponent).component('parcelLineStateHistory', _parcelLineStateHistory.parcelLineStateHistoryComponent);

exports.default = _module.name;


//////////////////
// WEBPACK FOOTER
// ./features/account/index.js
// module id = 847
// module chunks = 0